export default {
    themes: {
        'admin-tooltip': {
            $extend: 'tooltip',
            placement: 'bottom',
            distance: 2
        }
    }
}
